import React, { useRef } from 'react';
import { useTheme } from 'styled-components';
import { SignalMarkerVisualization } from '@area-monitoring/react-components';
import keycloak from '../../../keycloak';
import useAreaMonitoringDimensions from '../../../hooks/useAreaMonitoringDimensions';
import { PERFORMANCE_INDEX_LAYERS } from '../../Field/constants/performance-index-layers';
import styled from 'styled-components';
import { parseFullYearFromScope } from '../../../utils/utils';
import { t } from 'ttag';

const SignalChartWrap = styled.div`
  width: 100%;
  height: 100%;
  flex-grow: 1;
  flex-shrink: 0;
`;

export default function SignalChartComponent({
  performanceIndex,
  scope,
  selectedField,
  neighbouringFields,
  onDateClick,
  language,
  date,
}) {
  const signalChartRef = useRef();
  const theme = useTheme();
  const { width: signalMarkerWidth, height: signalMarkerHeight } =
    useAreaMonitoringDimensions(signalChartRef);

  function getSignalTypes() {
    const { signalId } = PERFORMANCE_INDEX_LAYERS.find(({ id }) => id === performanceIndex);
    if (!signalId) {
      return [];
    }

    const selectedFieldSignal = {
      signalTypeId: `${scope}.${signalId}`,
      shown: true,
      foiId: selectedField.id,
      label: t`Selected field`,
      lineColor: theme.fieldColor,
      bandOpacity: 1,
    };

    const neighbouringFieldsSignals = neighbouringFields
      .map(({ id, isSelected }, index) => ({
        signalTypeId: `${scope}.${signalId}`,
        shown: true,
        foiId: id,
        lineColor: theme[`selectedNeighbouringFieldColor_${index % 5}`],
        label: t`Neighbouring field` + ` ${index + 1}`,
        bandOpacity: 0.2,
        isSelected,
      }))
      .filter(({ isSelected }) => isSelected); // we filter afterwards to preserve initial indexes for labels

    return [...neighbouringFieldsSignals, selectedFieldSignal];
  }

  function getTimespan() {
    const year = parseFullYearFromScope(scope);
    const from = `${year}-01-01`;
    const to = `${year}-12-31`;
    return { from, to };
  }

  return (
    <SignalChartWrap className="signal-marker-wrap" ref={(el) => (signalChartRef.current = el)}>
      {signalChartRef.current && (
        <SignalMarkerVisualization
          width={signalMarkerWidth}
          height={signalMarkerHeight}
          scope={scope}
          timespan={getTimespan()}
          signalServiceUrl={'https://am-pilot.sinergise.com/signal/'}
          signalTypes={getSignalTypes()}
          amServicesAuthToken={keycloak.token}
          language={language}
          markerServiceUrl={'https://am-pilot.sinergise.com/marker/'}
          onDateSelect={(date) => {
            onDateClick(new Date(date));
          }}
          customMarker={{
            title: t`Selected date`,
            data: [date],
            color: 'black',
            width: 1.5,
            opacity: 1,
          }}
        />
      )}
    </SignalChartWrap>
  );
}
